export default __webpack_public_path__ + "static/media/client_5.c1832e85.png";